import React, { useRef, useState } from "react";
import { Button, Col, Modal, Row } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import InputText from "../../Input/InputText";
import "../../../../assets/style/modalStyle/addAccount.scss";
import { useDispatch, useSelector } from "react-redux";
import { accountSelector } from "../../../../services/selector/index.";
import LabelInput from "../../LabelInput";
import InputPassWord from "../../Input/InputPassWord";
import { valueSelectLicense } from "../../../../utils/ValueSelect";
import SelectValue from "../../Selector/SelectValue";
import {
  setMsg,
  setOpenPUEditAcc,
} from "../../../../services/slice/AccountSlice";
import { revertTypeAcc } from "../../../../utils/convertNumber";
import {
  containsWhitespace,
  isValidPass,
} from "../../../../utils/functionCommon";

const ModalEditUser = ({ handleEdit }) => {
  const stateUser = useSelector(accountSelector);
  const { contentEdit, msg } = stateUser;
  const [change, setChange] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    msg: "",
    errorIn: "",
  });
  const [data, setData] = useState({
    username: contentEdit.username,
    passwordNew: "",
    passwordRepeat: "",
    type: revertTypeAcc(contentEdit.type),
  });

  const handleCancel = () => {
    dispatch(setMsg(""));
    dispatch(setOpenPUEditAcc({ stateOpen: false, content: "" }));
  };
  const handleSubmit = () => {
    if (data.passwordNew || data.passwordRepeat) {
      if (data.passwordNew !== data.passwordRepeat) {
        setError({
          isError: true,
          msg: "Mật khẩu không trùng khớp. Vui lòng nhập lại",
          errorIn: "all",
        });
        return;
      }

      if (containsWhitespace(data.passwordNew)) {
        setError({
          isError: true,
          msg: "Mật khẩu không được chứa khoảng trắng",
          errorIn: "pass",
        });
        return;
      }
      if (data.passwordNew.length < 8) {
        setError({
          isError: true,
          msg: "Mật khẩu phải có độ dài từ 8 kí tự trở lên",
          errorIn: "pass",
        });
        return;
      }
      if (!isValidPass(data.passwordNew)) {
        setError({
          isError: true,
          msg: "Mật khẩu phải chứa 4 kiểu ký tự (a-z, A-Z, 0-9, #?!@$%^&*-.)",
          errorIn: "pass",
        });
        return;
      }
    }
    setChange(false);
    handleEdit(data);
    dispatch(setMsg(""));
  };

  return (
    <>
      <Modal
        maskClosable={false}
        style={{ position: "relative" }}
        title={t("Chỉnh sửa tài khoản")}
        centered
        width={570}
        className="warrperModalAddAcc"
        open={true}
        onCancel={handleCancel}
        footer={[
          <div className="evenSpace" style={{ marginTop: "1.5rem" }}>
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              disabled={
                !data.passwordNew && !data.passwordRepeat && !change
                  ? true
                  : false
              }
              width={155}
              content={"Lưu"}
              typeBtn="btnOrange"
              handleClick={handleSubmit}
            />
          </div>,
        ]}
      >
        <Row align={"middle"}>
          <Col span={10}>
            <LabelInput text={"Tên tài khoản"} />
          </Col>
          <Col span={14}>
            <InputText
              typeInput={"baseInput"}
              disable
              text={contentEdit.username}
              placeholder={"Nhập tên tài khoản"}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }} align={"middle"}>
          <Col span={10}>
            <LabelInput text={"Mật khẩu mới"} />
          </Col>
          <Col span={14}>
            <InputPassWord
              typeInput={"baseInput"}
              password={data.passwordNew}
              setPassWord={(value) => setData({ ...data, passwordNew: value })}
              placeholder={"Nhập mật khẩu mới"}
              style={
                (error.errorIn === "pass" && error.isError) ||
                (error.errorIn === "all" && error.isError)
                  ? { border: "1px solid red" }
                  : null
              }
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }} align={"middle"}>
          <Col span={10}>
            <LabelInput text={"Nhập lại mật khẩu mới"} />
          </Col>
          <Col span={14}>
            <InputPassWord
              typeInput={`baseInput ${
                !data.passwordRepeat ? "checkEmptyText" : null
              }`}
              password={data.passwordRepeat}
              setPassWord={(value) =>
                setData({ ...data, passwordRepeat: value })
              }
              style={
                (error.errorIn === "pass" && error.isError) ||
                (error.errorIn === "all" && error.isError)
                  ? { border: "1px solid red" }
                  : null
              }
              placeholder={"Nhập lại mật khẩu mới"}
            />
          </Col>
        </Row>
        <Row align={"middle"}>
          <Col span={10}>
            <LabelInput text={"Phân quyền"} />
          </Col>
          <Col span={14}>
            <SelectValue
              handleChange={(value) => {
                setChange(true);
                setData({ ...data, type: value });
              }}
              width={"100%"}
              defaultValue={
                valueSelectLicense.find((item) => item.value === data.type)
                  .label
              }
              type="base"
              optionsValue={valueSelectLicense}
              key="selectLinse"
            />
          </Col>
        </Row>
        {error.isError ? <small className="msg">{t(error.msg)}</small> : null}
      </Modal>
    </>
  );
};

export default ModalEditUser;
